export const formsIt: Record<string, string> = {
  'forms': 'Moduli',
  'forms.title': 'Moduli',
  'forms.subtitle': 'Crea e gestisci moduli incorporabili per il tuo sito web',
  'forms.newForm': 'Nuovo Modulo',
  'forms.createForm': 'Crea Modulo',
  'forms.noFormsTitle': 'Nessun modulo ancora',
  'forms.noFormsDesc': 'Crea il tuo primo modulo per iniziare a raccogliere contatti dal tuo sito web',
  'forms.version': 'Versione',
  'forms.submissions': 'Invii',
  'forms.language': 'Lingua',
  'forms.edit': 'Modifica',
  'forms.duplicate': 'Duplica',
  'forms.duplicateSuccess': 'Modulo duplicato con successo',
  'forms.duplicateError': 'Impossibile duplicare il modulo',
  'forms.status.draft': 'Bozza',
  'forms.status.published': 'Pubblicato',
  'forms.status.archived': 'Archiviato',
  'forms.builder.save': 'Salva',
  'forms.builder.saving': 'Salvando...',
  'forms.builder.publish': 'Pubblica',
  'forms.builder.publishing': 'Pubblicazione...',
  'forms.builder.unpublish': 'Annulla Pubblicazione',
  'forms.builder.unpublishing': 'Annullando...',
  'forms.builder.tab_builder': 'Costruttore',
  'forms.builder.tab_display': 'Visualizzazione',
  'forms.builder.tab_settings': 'Impostazioni',
  'forms.builder.tab_preview': 'Anteprima',
  'forms.builder.version_created': 'Nuova versione bozza creata (v{version})',
  'forms.builder.saved': 'Modulo salvato (v{version})',
  'forms.builder.published_success': 'Modulo pubblicato con successo',
  'forms.builder.unpublished_success': 'Pubblicazione modulo annullata con successo',
  'forms.builder.save_failed': 'Impossibile salvare il modulo',
  'forms.builder.publish_failed': 'Impossibile pubblicare il modulo',
  'forms.builder.unpublish_failed': 'Impossibile annullare la pubblicazione',
  'forms.builder.load_failed': 'Impossibile caricare i dati del modulo',
  'forms.builder.advanced.templates.title': 'Template Modulo',
  'forms.builder.advanced.templates.description': 'Scegli tra template predefiniti per configurare rapidamente la struttura del modulo',
  'forms.builder.advanced.templates.applied': 'Template "{name}" applicato',
  'forms.mappingTemplates.title': 'Template Mappature',
  'forms.mappingTemplates.categoryTemplates': 'Template {category}',
  'forms.mappingTemplates.fields': 'campi',
  'forms.mappingTemplates.fieldsIncluded': 'Campi inclusi ({count}):',
  'forms.mappingTemplates.required': 'Obbligatorio',
  'forms.mappingTemplates.actions.preview': 'Anteprima',
  'forms.mappingTemplates.actions.applyTemplate': 'Applica Template',
  'forms.mappingTemplates.actions.apply': 'Applica',
  'forms.mappingTemplates.toast.appliedTitle': 'Template applicato',
  'forms.mappingTemplates.toast.appliedDescription': 'Il template {templateName} è stato applicato con {fieldCount} mappature campo.',
  'forms.mappingTemplates.categories.bridal': 'Sposa',
  'forms.mappingTemplates.categories.business': 'Business',
  'forms.mappingTemplates.categories.general': 'Generale',
  'forms.mappingTemplates.categories.ecommerce': 'Ecommerce',
  'forms.mappingTemplates.template.bridalInquiry.name': 'Modulo Richiesta Sposa',
  'forms.mappingTemplates.template.bridalInquiry.description': 'Modulo completo di consulenza sposa con dettagli matrimonio e preferenze',
  'forms.mappingTemplates.template.businessContact.name': 'Modulo Contatto Business',
  'forms.mappingTemplates.template.businessContact.description': 'Modulo standard di richiesta business per generazione lead',
  'forms.mappingTemplates.template.customerRegistration.name': 'Registrazione Cliente',
  'forms.mappingTemplates.template.customerRegistration.description': 'Modulo completo di creazione profilo cliente',
  'forms.mappingTemplates.template.appointmentBooking.name': 'Prenotazione Appuntamento',
  'forms.mappingTemplates.template.appointmentBooking.description': 'Pianifica appuntamenti con dettagli cliente',
  'forms.mappingTemplates.template.productInquiry.name': 'Richiesta Prodotto',
  'forms.mappingTemplates.template.productInquiry.description': 'Modulo di interesse prodotto e specifiche',
  'forms.mappingTemplates.labels.brideName': 'Nome Sposa',
  'forms.mappingTemplates.labels.partnerName': 'Nome Partner',
  'forms.mappingTemplates.labels.emailAddress': 'Indirizzo Email',
  'forms.mappingTemplates.labels.phoneNumber': 'Numero di Telefono',
  'forms.mappingTemplates.labels.weddingDate': 'Data Matrimonio',
  'forms.mappingTemplates.labels.ceremonyVenue': 'Location Cerimonia',
  'forms.mappingTemplates.labels.receptionVenue': 'Location Ricevimento',
  'forms.mappingTemplates.labels.dressSize': 'Taglia Abito',
  'forms.mappingTemplates.labels.budgetRange': 'Fascia Budget',
  'forms.mappingTemplates.labels.stylePreferences': 'Preferenze Stile',
  'forms.mappingTemplates.labels.brandPreferences': 'Preferenze Brand',
  'forms.mappingTemplates.labels.inspirationImages': 'Immagini Ispirazione',
  'forms.mappingTemplates.labels.shoppingTimeline': 'Tempistiche Acquisto',
  'forms.mappingTemplates.labels.interestedInAlterations': 'Interessata alle Modifiche',
  'forms.mappingTemplates.labels.shoppingForBridesmaids': 'Acquisto per Damigelle',
  'forms.mappingTemplates.labels.interestedInAccessories': 'Interessata agli Accessori',
  'forms.mappingTemplates.labels.specialRequests': 'Richieste Speciali',
  'forms.mappingTemplates.labels.firstName': 'Nome',
  'forms.mappingTemplates.labels.lastName': 'Cognome',
  'forms.mappingTemplates.labels.companyName': 'Nome Azienda',
  'forms.mappingTemplates.labels.jobTitle': 'Ruolo',
  'forms.mappingTemplates.labels.industry': 'Settore',
  'forms.mappingTemplates.labels.companySize': 'Dimensione Azienda',
  'forms.mappingTemplates.labels.inquiryType': 'Tipo Richiesta',
  'forms.mappingTemplates.labels.projectTimeline': 'Tempistiche Progetto',
  'forms.mappingTemplates.labels.message': 'Messaggio',
  'forms.mappingTemplates.labels.address': 'Indirizzo',
  'forms.mappingTemplates.labels.city': 'Città',
  'forms.mappingTemplates.labels.stateProvince': 'Provincia/Stato',
  'forms.mappingTemplates.labels.zipPostalCode': 'CAP/Codice Postale',
  'forms.mappingTemplates.labels.country': 'Paese',
  'forms.mappingTemplates.labels.dateOfBirth': 'Data di Nascita',
  'forms.mappingTemplates.labels.howDidYouHear': 'Come ci hai conosciuto?',
  'forms.mappingTemplates.labels.marketingConsent': 'Accetto di ricevere comunicazioni marketing',
  'forms.mappingTemplates.labels.termsAccepted': 'Accetto termini e condizioni',
  'forms.mappingTemplates.labels.fullName': 'Nome Completo',
  'forms.mappingTemplates.labels.preferredDate': 'Data Preferita',
  'forms.mappingTemplates.labels.preferredTime': 'Orario Preferito',
  'forms.mappingTemplates.labels.appointmentType': 'Tipo Appuntamento',
  'forms.mappingTemplates.labels.servicesOfInterest': 'Servizi di Interesse',
  'forms.mappingTemplates.labels.additionalNotes': 'Note Aggiuntive',
  'forms.mappingTemplates.labels.emergencyContact': 'Contatto di Emergenza',
  'forms.mappingTemplates.labels.specialAccommodations': 'Esigenze Speciali',
  'forms.mappingTemplates.labels.customerName': 'Nome Cliente',
  'forms.mappingTemplates.labels.productOfInterest': 'Prodotto di Interesse',
  'forms.mappingTemplates.labels.colorPreferences': 'Preferenze Colore',
  'forms.mappingTemplates.labels.sizeNeeded': 'Taglia Necessaria',
  'forms.mappingTemplates.labels.quantity': 'Quantità',
  'forms.mappingTemplates.labels.deliveryTimeline': 'Quando ti serve?',
  'forms.mappingTemplates.labels.customizationRequired': 'Personalizzazione Richiesta',
  'forms.mappingTemplates.labels.detailedSpecifications': 'Specifiche Dettagliate',
  'forms.mappingTemplates.placeholders.projectDetails': 'Parlaci del tuo progetto...',
  'forms.builder.advanced.mapping.title': 'Analisi mappatura campi',
  'forms.builder.advanced.mapping.description': 'Panoramica visiva di come i campi del modulo vengono mappati alle entità dati con rilevamento conflitti',
  'forms.builder.advanced.testing.title': 'Test e validazione modulo',
  'forms.builder.advanced.testing.description': 'Testa il modulo con vari scenari e valida le mappature dei campi',
  'forms.builder.advanced.backup.title': 'Backup e controllo versioni',
  'forms.builder.advanced.backup.description': 'Crea backup e ripristina versioni precedenti del modulo',
  'forms.builder.advanced.backup.restored': 'Modulo ripristinato dal backup',
  'forms.display.title': 'Impostazioni Visualizzazione',
  'forms.display.logo_section': 'Visualizzazione Logo',
  'forms.display.logo_toggle': 'Mostra Logo Organizzazione',
  'forms.display.logo_help': 'Mostra il logo della tua organizzazione in cima al modulo',
  'forms.display.text_content': 'Contenuto Testo Modulo',
  'forms.display.form_title': 'Titolo Modulo',
  'forms.display.form_title_help': 'Titolo mostrato nell\'intestazione della scheda modulo',
  'forms.display.header_text': 'Testo Intestazione',
  'forms.display.header_text_help': 'Intestazione principale mostrata in cima al modulo',
  'forms.display.description_text': 'Testo Descrizione',
  'forms.display.description_help': 'Sottotitolo o descrizione mostrata sotto l\'intestazione',
  'forms.display.powered_by_toggle': 'Mostra Footer "Powered by"',
  'forms.display.powered_by_help': 'Mostra testo di attribuzione in fondo al modulo',
  'forms.display.footer_text': 'Testo Footer',
  'forms.display.footer_help': 'Testo mostrato nel footer del modulo',
  'forms.display.submit_button': 'Testo Pulsante Invio',
  'forms.display.submit_help': 'Testo mostrato sul pulsante di invio del modulo',
  'forms.display.placeholder_title_en': 'Modulo di Contatto',
  'forms.display.placeholder_header_en': 'Nome della Tua Organizzazione',
  'forms.display.placeholder_description_en': 'Compila il modulo qui sotto e ti risponderemo presto.',
  'forms.display.placeholder_footer_en': 'Powered by La Tua Organizzazione',
  'forms.display.placeholder_submit_en': 'Invia Modulo',
  'forms.create.title': 'Crea Nuovo Modulo',
  'forms.create.formName': 'Nome Modulo',
  'forms.create.formKey': 'Chiave Modulo',
  'forms.create.defaultLanguage': 'Lingua Predefinita',
  'forms.create.placeholders.name': 'Modulo di Contatto',
  'forms.create.placeholders.key': 'modulo-contatto',
  'forms.create.formKeyDesc': "Usata nell'URL di incorporamento (es., tuosito.com/forms/modulo-contatto)",
  'forms.create.formKeyPatternHelp': 'Sono consentite solo lettere minuscole, numeri e trattini',
  'forms.create.cancel': 'Annulla',
  'forms.create.creating': 'Creazione...',
  'forms.create.createForm': 'Crea Modulo',
  'forms.create.success': 'Modulo creato con successo',
  'forms.create.error': 'Impossibile creare il modulo',
  'forms.embed.title': 'Incorpora Modulo',
  'forms.embed.key': 'Chiave',
  'forms.embed.warning': 'Questo modulo non è ancora pubblicato. Pubblica prima il modulo per renderlo disponibile per l\'incorporamento.',
  'forms.embed.copySuccess': '{label} copiato negli appunti',
  'forms.embed.copyError': 'Impossibile copiare negli appunti',
  'forms.embed.publishNote': 'Solo i moduli pubblicati possono essere incorporati nei siti web',
  'forms.embed.close': 'Chiudi',
  'forms.embed.tabs.script': 'Incorporamento Script',
  'forms.embed.tabs.iframe': 'Incorporamento Iframe',
  'forms.embed.tabs.custom': 'Personalizzato',
  'forms.embed.tabs.tracking': 'Tracciamento',
  'forms.embed.tabs.direct': 'Link Diretto',
  'forms.embed.label.scriptEmbed': 'Embed script',
  'forms.embed.label.iframeEmbed': 'Embed iframe',
  'forms.embed.label.customEmbed': 'Embed personalizzato',
  'forms.embed.label.trackingCode': 'Codice tracciamento',
  'forms.embed.script.title': 'Incorporamento Script (Consigliato)',
  'forms.embed.script.desc': 'Carica dinamicamente il modulo nella tua pagina con stile automatico',
  'forms.embed.script.htmlCode': 'Codice HTML',
  'forms.embed.script.pros': 'Vantaggi',
  'forms.embed.script.pro1': 'Si adatta automaticamente allo stile del tuo sito',
  'forms.embed.script.pro2': 'Responsivo e ottimizzato per mobile',
  'forms.embed.script.pro3': 'Si aggiorna automaticamente quando il modulo cambia',
  'forms.embed.script.pro4': 'Migliori prestazioni e SEO',
  'forms.embed.script.requirements': 'Requisiti',
  'forms.embed.script.req1': 'JavaScript deve essere abilitato',
  'forms.embed.script.req2': 'CORS deve consentire il nostro dominio',
  'forms.embed.script.req3': 'Browser moderno richiesto',
  'forms.embed.iframe.title': 'Incorporamento Iframe',
  'forms.embed.iframe.desc': 'Incorpora il modulo in un iframe con dimensioni fisse',
  'forms.embed.iframe.preview': 'Anteprima',
  'forms.embed.iframe.cons': 'Svantaggi',
  'forms.embed.iframe.pro1': 'Funziona senza JavaScript',
  'forms.embed.iframe.pro2': 'Isolato dalla pagina principale',
  'forms.embed.iframe.pro3': 'Facile da implementare',
  'forms.embed.iframe.con1': 'Altezza fissa può causare scrolling',
  'forms.embed.iframe.con2': 'Non completamente responsivo',
  'forms.embed.iframe.con3': 'Limitazioni SEO',
  'forms.embed.custom.title': 'Incorporamento Personalizzato',
  'forms.embed.custom.desc': 'Incorporamento script con opzioni di personalizzazione aggiuntive',
  'forms.embed.custom.code': 'Codice Personalizzato',
  'forms.embed.custom.attributes': 'Attributi Disponibili',
  'forms.embed.custom.attr.form': 'Identificatore modulo (obbligatorio)',
  'forms.embed.custom.attr.org': 'ID Organizzazione (obbligatorio)',
  'forms.embed.custom.attr.lang': 'Codice lingua (en, it, etc.)',
  'forms.embed.custom.attr.theme': 'Tema (light, dark)',
  'forms.embed.custom.attr.primary': 'Colore primario (codice hex)',
  'forms.embed.custom.attr.style': 'Stili CSS personalizzati',
  'forms.embed.direct.title': 'Link Diretto',
  'forms.embed.direct.desc': 'URL diretto alla pagina del modulo - perfetto per social media ed email',
  'forms.embed.direct.url': 'URL Diretto',
  'forms.embed.direct.showQR': 'Mostra Codice QR',
  'forms.embed.direct.hideQR': 'Nascondi Codice QR',
  'forms.embed.direct.useCases': 'Perfetto per',
  'forms.embed.direct.case1': 'Post e storie sui social media',
  'forms.embed.direct.case2': 'Campagne email e newsletter',
  'forms.embed.direct.case3': 'Codici QR per materiali stampati',
  'forms.embed.direct.case4': 'Condivisione mobile veloce',
  'forms.embed.tracking.title': 'Configurazione tracciamento conversioni',
  'forms.embed.tracking.description': 'Traccia gli invii del modulo con Meta Pixel, Google Ads o altre piattaforme di analytics.',
  'forms.embed.tracking.step1Title': 'Passo 1: Abilita il tracciamento nelle impostazioni modulo',
  'forms.embed.tracking.step1Description': 'Vai in Impostazioni Modulo -> Tracciamento conversioni e abilita le notifiche al parent.',
  'forms.embed.tracking.step2Title': 'Passo 2: Aggiungi il listener alla tua pagina',
  'forms.embed.tracking.step2Description': 'Aggiungi questo codice alla pagina parent che incorpora il modulo:',
  'forms.embed.tracking.messageFormat': 'Formato messaggio',
  'forms.embed.tracking.proTipsTitle': 'Suggerimenti',
  'forms.embed.tracking.tip1': 'Usa eventId per la deduplicazione con Conversions API',
  'forms.embed.tracking.tip2': 'Imposta gli origin consentiti nelle impostazioni modulo per sicurezza',
  'forms.embed.tracking.tip3': 'Verifica dal browser console che i messaggi vengano inviati',
  'forms.embed.tracking.tip4': 'Funziona sia con embed iframe sia con script',
  'forms.submissions.title': 'Invii del Modulo',
  'forms.submissions.export': 'Esporta CSV',
  'forms.submissions.search': 'Cerca negli invii...',
  'forms.submissions.allLanguages': 'Tutte le Lingue',
  'forms.submissions.noSubmissions': 'Nessun invio trovato',
  'forms.submissions.noData': 'Nessun invio da esportare',
  'forms.submissions.exportSuccess': 'CSV esportato con successo',
  'forms.submissions.exportError': "Errore nell'esportazione CSV",
  'forms.submissions.consent': 'Consenso',
  'forms.submissions.openLead': 'Apri Contatto',
  'forms.submissions.leadRemoved': 'Contatto Rimosso',
  'forms.submissions.createLead': 'Crea Contatto',
  'forms.submissions.contactUnavailable': 'Informazioni di contatto del lead non più disponibili',
  'forms.submissions.contact': 'Contatto',
  'forms.submissions.pageUrl': 'URL Pagina',
  'forms.analytics.title': 'Analytics Modulo',
  'forms.analytics.range.last7Days': 'Ultimi 7 giorni',
  'forms.analytics.range.last30Days': 'Ultimi 30 giorni',
  'forms.analytics.range.last90Days': 'Ultimi 90 giorni',
  'forms.analytics.exportReport': 'Esporta report',
  'forms.analytics.tabs.overview': 'Panoramica',
  'forms.analytics.tabs.submissions': 'Invii',
  'forms.analytics.tabs.conversions': 'Conversioni',
  'forms.analytics.tabs.fieldAnalysis': 'Analisi campi',
  'forms.analytics.metrics.totalSubmissions': 'Invii totali',
  'forms.analytics.metrics.inLastDays': 'Negli ultimi {days} giorni',
  'forms.analytics.metrics.uniqueVisitors': 'Visitatori unici',
  'forms.analytics.metrics.basedOnIp': 'Basato su indirizzi IP',
  'forms.analytics.metrics.conversionRate': 'Tasso di conversione',
  'forms.analytics.metrics.submissionsPerVisitors': 'Invii / Visitatori',
  'forms.analytics.metrics.avgDaily': 'Media giornaliera',
  'forms.analytics.metrics.submissionsPerDay': 'Invii al giorno',
  'forms.analytics.noData': 'Nessun dato analytics disponibile',
  'forms.properties.dataPreview': 'Anteprima Dati',
  'forms.properties.leadFields': 'Campi Contatto',
  'forms.properties.customerFields': 'Campi Cliente',
  'forms.properties.customFields': 'Campi Personalizzati',
  'forms.properties.selectDataField': 'Seleziona un campo dati a cui mappare questo campo modulo',
  'forms.properties.noMappingSelected': 'Nessuna mappatura selezionata',
  'forms.properties.email': 'Email',
  'forms.properties.firstName': 'Nome',
  'forms.properties.lastName': 'Cognome',
  'forms.properties.phone': 'Telefono',
  'forms.properties.budgetMin': 'Budget Min',
  'forms.properties.budgetMax': 'Budget Max',
  'forms.properties.eventDate': 'Data Evento',
  'forms.properties.eventLocation': 'Luogo Evento',
  'forms.properties.partnerName': 'Nome Partner',
  'forms.properties.source': 'Fonte',
  'forms.properties.notes': 'Note',
  'forms.properties.howDidYouHear': 'Come ci hai conosciuto',
  'forms.properties.dreamWeddingDescription': 'Descrizione Matrimonio dei Sogni',
  'forms.properties.specialRequests': 'Richieste Speciali',
  'forms.properties.guestCount': 'Numero Ospiti',
  'forms.properties.ceremony': 'Cerimonia',
  'forms.properties.reception': 'Ricevimento',
  'forms.properties.honeymoon': 'Luna di Miele',
  'forms.properties.dressSize': 'Taglia Abito',
  'forms.properties.dressStyle': 'Stile Abito',
  'forms.properties.shoeSize': 'Numero Scarpe',
  'forms.properties.hasChildren': 'Ha Figli',
  'forms.properties.address': 'Indirizzo',
  'forms.properties.city': 'Città',
  'forms.properties.country': 'Paese',
  'forms.properties.customField1': 'Campo Personalizzato 1',
  'forms.properties.customField2': 'Campo Personalizzato 2',
  'forms.properties.customField3': 'Campo Personalizzato 3',
  'forms.properties.customField4': 'Campo Personalizzato 4',
  'forms.properties.customField5': 'Campo Personalizzato 5',
  'forms.properties.utmSource': 'UTM Source',
  'forms.properties.utmCampaign': 'UTM Campaign',
  'forms.properties.referrer': 'Referrer',
  'forms.properties.weddingDate': 'Data Matrimonio',
  'forms.properties.ceremonyVenue': 'Location Cerimonia',
  'forms.properties.receptionVenue': 'Location Ricevimento',
  'forms.palette.title': 'Campi del Modulo',
  'forms.palette.instruction': 'Trascina e rilascia i campi sulla tela per costruire il tuo modulo',
  'forms.palette.fields.text': 'Campo di Testo',
  'forms.palette.descriptions.text': 'Campo di testo a riga singola',
  'forms.palette.fields.textarea': 'Area di Testo',
  'forms.palette.descriptions.textarea': 'Campo di testo multi-riga',
  'forms.palette.fields.email': 'Email',
  'forms.palette.descriptions.email': 'Campo email con validazione',
  'forms.palette.fields.phone': 'Telefono',
  'forms.palette.descriptions.phone': 'Campo telefono con formattazione',
  'forms.palette.fields.number': 'Numero',
  'forms.palette.descriptions.number': 'Campo numerico',
  'forms.palette.fields.date': 'Data',
  'forms.palette.descriptions.date': 'Selettore di data',
  'forms.palette.fields.datetime': 'Data e Ora',
  'forms.palette.descriptions.datetime': 'Selettore di data e ora',
  'forms.palette.fields.select': 'Menu a Tendina',
  'forms.palette.descriptions.select': 'Menu a tendina a selezione singola',
  'forms.palette.fields.multiselect': 'Selezione Multipla',
  'forms.palette.descriptions.multiselect': 'Menu a selezione multipla',
  'forms.palette.fields.checkbox': 'Casella di Controllo',
  'forms.palette.descriptions.checkbox': 'Casella di controllo per opzioni sì/no',
  'forms.palette.fields.radio': 'Pulsanti Radio',
  'forms.palette.descriptions.radio': 'Scelta singola tra opzioni multiple',
  'forms.palette.fields.file': 'Caricamento File',
  'forms.palette.descriptions.file': 'Campo per caricamento file',
  'forms.palette.fields.country': 'Paese',
  'forms.palette.descriptions.country': 'Menu di selezione paese',
  'forms.palette.fields.language': 'Lingua',
  'forms.palette.descriptions.language': 'Menu di selezione lingua',
  'forms.palette.fields.consent': 'Consenso',
  'forms.palette.descriptions.consent': 'Casella di consenso con testo personalizzato',
  'forms.palette.fields.hidden': 'Campo Nascosto',
  'forms.palette.descriptions.hidden': 'Campo nascosto per tracciamento dati',
  'forms.canvas.title': 'Costruttore Modulo',
  'forms.canvas.instruction': 'Trascina i campi qui per costruire il tuo modulo',
  'forms.canvas.instructions': 'Trascina i campi per riordinarli. Clicca per modificare le proprietà.',
  'forms.canvas.emptyState': 'Nessun campo ancora. Scegli i campi dalla palette per iniziare.',
  'forms.canvas.dragHandle': 'Trascina per riordinare',
  'forms.canvas.deleteField': 'Elimina campo',
  'forms.canvas.selectField': 'Clicca per modificare le proprietà del campo',
  'forms.canvas.noFields': 'Nessun campo ancora',
  'forms.canvas.addFields': 'Aggiungi campi dalla palette per iniziare',
  'forms.canvas.selectOption': "Seleziona un'opzione",
  'forms.canvas.selectCountry': 'Seleziona paese',
  'forms.canvas.selectLanguage': 'Seleziona lingua',
  'forms.canvas.italy': 'Italia',
  'forms.canvas.unitedStates': 'Stati Uniti',
  'forms.canvas.unitedKingdom': 'Regno Unito',
  'forms.canvas.english': 'Inglese',
  'forms.canvas.italian': 'Italiano',
  'forms.canvas.french': 'Francese',
  'forms.canvas.hiddenField': 'Campo nascosto:',
  'forms.canvas.uploadText': 'Clicca per caricare o trascina e rilascia',
  'forms.properties.title': 'Proprietà del Campo',
  'forms.properties.basicTab': 'Base',
  'forms.properties.localesTab': 'Lingue',
  'forms.properties.mappingTab': 'Mappatura',
  'forms.properties.label': 'Etichetta',
  'forms.properties.placeholder': 'Segnaposto',
  'forms.properties.required': 'Obbligatorio',
  'forms.properties.defaultValue': 'Valore Predefinito',
  'forms.properties.validation': 'Validazione',
  'forms.properties.options': 'Opzioni',
  'forms.properties.addOption': 'Aggiungi Opzione',
  'forms.properties.helpText': 'Testo di Aiuto',
  'forms.properties.consentText': 'Testo di Consenso',
  'forms.properties.minLength': 'Lunghezza Minima',
  'forms.properties.maxLength': 'Lunghezza Massima',
  'forms.properties.minValue': 'Valore Minimo',
  'forms.properties.maxValue': 'Valore Massimo',
  'forms.properties.pattern': 'Pattern (Regex)',
  'forms.properties.patternMessage': 'Messaggio Errore Pattern',
  'forms.properties.labelLocale': 'Etichetta ({locale})',
  'forms.properties.placeholderLocale': 'Segnaposto ({locale})',
  'forms.properties.helpTextLocale': 'Testo di Aiuto ({locale})',
  'forms.properties.consentTextLocale': 'Testo di Consenso ({locale})',
  'forms.properties.mapToField': 'Mappa a Campo',
  'forms.properties.mappingHelp': 'Collega questo campo a un campo dati cliente',
  'forms.properties.selectMapping': 'Seleziona mappatura campo',
  'forms.properties.selectField': 'Seleziona un campo per modificarne le proprietà',
  'forms.properties.fieldInfo': 'Informazioni campo',
  'forms.properties.typeLabel': 'Tipo:',
  'forms.properties.idLabel': 'ID:',
  'forms.properties.requiredLabel': 'Obbligatorio:',
  'forms.properties.optionsLabel': 'Opzioni:',
  'forms.properties.itemsCount': 'elementi',
  'forms.properties.yes': 'Sì',
  'forms.properties.no': 'No',
  'forms.properties.placeholder.fieldLabel': 'Etichetta campo',
  'forms.properties.placeholder.placeholderText': 'Testo segnaposto',
  'forms.properties.optionPlaceholder': 'Opzione {number}',
  'forms.properties.helpTextPlaceholder': 'Testo di aiuto aggiuntivo per questo campo',
  'forms.properties.fieldPath': 'Percorso campo:',
  'forms.properties.descriptionLabel': 'Descrizione:',
  'forms.properties.descriptionLead': 'I dati verranno salvati nel record del contatto',
  'forms.properties.descriptionCustomer': 'I dati verranno salvati nel profilo cliente',
  'forms.properties.descriptionCustom': 'I dati verranno salvati come attributo personalizzato',
  'forms.properties.entityLead': 'Contatto',
  'forms.properties.entityCustomer': 'Cliente',
  'forms.properties.entityCustom': 'Personalizzato',
  'forms.properties.leadPrefix': 'Contatto ->',
  'forms.properties.customerPrefix': 'Cliente ->',
  'forms.properties.customLeadPrefix': 'Personalizzato (Contatto) ->',
  'forms.properties.customCustomerPrefix': 'Personalizzato (Cliente) ->',
  'forms.properties.customPrefix': 'Personalizzato ->',
  'forms.preview.title': 'Anteprima Modulo',
  'forms.preview.empty': 'Nessun campo da visualizzare',
  'forms.preview.emptyDesc': "Aggiungi campi al modulo per vedere l'anteprima",
  'forms.preview.instructions': 'Anteprima del modulo come apparirà agli utenti',
  'forms.preview.submit': 'Invia Modulo',
  'forms.preview.reset': 'Reimposta',
  'forms.preview.submitting': 'Invio in corso...',
  'forms.preview.success': 'Modulo inviato con successo!',
  'forms.preview.error': "Errore nell'invio del modulo",
  'forms.preview.validation.required': 'Questo campo è obbligatorio',
  'forms.preview.validation.email': 'Inserisci un indirizzo email valido',
  'forms.preview.validation.minLength': 'Inserisci almeno {min} caratteri',
  'forms.preview.validation.maxLength': 'Inserisci massimo {max} caratteri',
  'forms.preview.validation.min': 'Il valore deve essere almeno {min}',
  'forms.preview.validation.max': 'Il valore non può superare {max}',
  'forms.preview.validation.pattern': 'Il formato non è valido',
  'forms.preview.placeholders.text': 'Inserisci testo...',
  'forms.preview.placeholders.email': 'tua@email.com',
  'forms.preview.placeholders.phone': '+39 123 456 7890',
  'forms.preview.placeholders.number': '0',
  'forms.preview.placeholders.textarea': 'Inserisci il tuo messaggio...',
  'forms.preview.placeholders.select': "Seleziona un'opzione",
  'forms.preview.country.italy': 'Italia',
  'forms.preview.country.usa': 'Stati Uniti',
  'forms.preview.country.uk': 'Regno Unito',
  'forms.preview.country.france': 'Francia',
  'forms.preview.country.germany': 'Germania',
  'forms.preview.country.spain': 'Spagna',
  'forms.preview.language.en': 'Inglese',
  'forms.preview.language.it': 'Italiano',
  'forms.preview.language.fr': 'Francese',
  'forms.preview.language.de': 'Tedesco',
  'forms.preview.language.es': 'Spagnolo',
  'forms.preview.consent.text': 'Accetto i termini e le condizioni',
  'forms.preview.consent.required': 'Devi accettare i termini per continuare',
  'forms.preview.testMode': 'Modalità Test',
  'forms.preview.language': 'Lingua',
  'forms.preview.submitForm': 'Invia Modulo',
  'forms.preview.resetForm': 'Reimposta Modulo',
  'forms.preview.selectOption': "Seleziona un'opzione",
  'forms.preview.selectCountry': 'Seleziona paese',
  'forms.preview.selectLanguage': 'Seleziona lingua',
  'forms.preview.noFields': 'Nessun campo da mostrare in anteprima',
  'forms.preview.addFieldsToPreview': "Aggiungi campi per visualizzare l'anteprima del modulo",
  'forms.preview.italy': 'Italia',
  'forms.preview.unitedStates': 'Stati Uniti',
  'forms.preview.unitedKingdom': 'Regno Unito',
  'forms.preview.france': 'Francia',
  'forms.preview.germany': 'Germania',
  'forms.preview.spain': 'Spagna',
  'forms.preview.english': 'Inglese',
  'forms.preview.italian': 'Italiano',
  'forms.preview.french': 'Francese',
  'forms.preview.german': 'Tedesco',
  'forms.preview.spanish': 'Spagnolo',
  'forms.preview.uploadText': 'Clicca per caricare o trascina e rilascia',
  'forms.preview.maxFileSize': 'Dimensione massima file: 10MB',
  'forms.preview.notImplemented': 'tipo di campo non ancora implementato',
  'forms.settings.title': 'Impostazioni Modulo',
  'forms.settings.success.title': 'Comportamento di Successo',
  'forms.settings.success.message': 'Messaggio di Successo',
  'forms.settings.success.redirect': 'URL di Reindirizzamento',
  'forms.settings.success.placeholders.message': 'Grazie per il tuo invio!',
  'forms.settings.success.placeholders.url': 'https://tuosito.com/grazie',
  'forms.settings.spam': 'Protezione Spam',
  'forms.settings.spam.honeypot': 'Protezione Honeypot',
  'forms.settings.spam.honeypotHelp': 'Campo nascosto per rilevare bot spam',
  'forms.settings.spam.rateLimit': 'Limite Velocità',
  'forms.settings.spam.rateLimitHelp': 'Massimo {count} invii per IP ogni {minutes} minuti',
  'forms.settings.spam.recaptcha': 'reCAPTCHA v3',
  'forms.settings.spam.recaptchaHelp': 'Protezione Google reCAPTCHA invisibile',
  'forms.settings.notifications': 'Notifiche',
  'forms.settings.notifications.email': 'Notifiche Email',
  'forms.settings.notifications.emailHelp': 'Invia email quando viene inviato il modulo',
  'forms.settings.notifications.recipients': 'Destinatari Email',
  'forms.settings.notifications.addRecipient': 'Aggiungi Destinatario',
  'forms.settings.notifications.subject': 'Oggetto Email',
  'forms.settings.notifications.subjectPlaceholder': 'Nuovo invio modulo da {formName}',
  'forms.settings.notifications.inApp': 'Notifiche In-App',
  'forms.settings.notifications.inAppHelp': 'Mostra notifiche nel dashboard',
  'forms.settings.notifications.webhook': 'Integrazione Webhook',
  'forms.settings.notifications.webhookHelp': 'Invia dati modulo a un endpoint personalizzato',
  'forms.settings.notifications.webhookUrl': 'URL Webhook',
  'forms.settings.notifications.webhookSecret': 'Chiave Segreta Webhook',
  'forms.settings.successBehavior': 'Comportamento di Successo',
  'forms.settings.spamProtection': 'Protezione Spam',
  'forms.settings.behaviorType': 'Tipo Comportamento',
  'forms.settings.showMessage': 'Mostra Messaggio',
  'forms.settings.redirectToUrl': 'Reindirizza a URL',
  'forms.settings.successMessageLocale': 'Messaggio di Successo ({locale})',
  'forms.settings.redirectUrlLocale': 'URL di Reindirizzamento ({locale})',
  'forms.settings.english': 'Inglese',
  'forms.settings.italian': 'Italiano',
  'forms.settings.enableHoneypot': 'Abilita Protezione Honeypot',
  'forms.settings.honeypotDesc': 'Campo nascosto per catturare i bot',
  'forms.settings.honeypotFieldName': 'Nome Campo Honeypot',
  'forms.settings.rateLimit': "Limite Velocità (invii per IP all'ora)",
  'forms.settings.recaptcha': 'reCAPTCHA v3',
  'forms.settings.recaptchaDesc': 'Richiede configurazione chiave del sito',
  'forms.settings.minScore': 'Punteggio Minimo (0.0 - 1.0)',
  'forms.settings.emailNotifications': 'Notifiche Email',
  'forms.settings.emailDesc': 'Invia avvisi email quando i moduli vengono inviati',
  'forms.settings.emailRecipients': 'Destinatari Email',
  'forms.settings.emailSubject': 'Template Oggetto Email',
  'forms.settings.placeholders.email': 'email@esempio.com',
  'forms.settings.inAppNotifications': 'Notifiche In-App',
  'forms.settings.inAppDesc': "Mostra notifiche nell'app",
  'forms.settings.webhookIntegration': 'Integrazione Webhook',
  'forms.settings.webhookDesc': "Invia richieste HTTP POST all'invio del modulo",
  'forms.settings.webhookUrl': 'URL Webhook',
  'forms.settings.secretKey': 'Chiave Segreta (opzionale)',
  'forms.settings.secretKeyDesc': 'Utilizzata per la verifica della firma HMAC',
  'forms.settings.hmacHelp': "Utilizzata per generare la firma HMAC-SHA256 per verificare l'integrità dei dati",
  'forms.settings.tracking.title': 'Tracciamento conversioni',
  'forms.settings.tracking.description': 'Abilita il tracciamento per Meta Pixel, Google Ads e altre piattaforme analytics quando i moduli sono incorporati in iframe.',
  'forms.settings.tracking.enableParentNotifications': 'Abilita notifiche al parent',
  'forms.settings.tracking.parentNotificationsHelp': 'Invia postMessage alla finestra parent quando il modulo viene inviato',
  'forms.settings.tracking.trackLeadValue': 'Traccia valore lead',
  'forms.settings.tracking.trackLeadValueHelp': 'Includi il valore lead nel payload di tracciamento',
  'forms.settings.tracking.defaultLeadValue': 'Valore lead predefinito',
  'forms.settings.tracking.defaultLeadValueHelp': 'Valore da assegnare a ogni invio modulo per il tracciamento ROI',
  'forms.settings.tracking.allowedParentOrigins': 'Origini parent consentite (opzionale)',
  'forms.settings.tracking.allowedParentOriginsHelp': 'Una origine per riga. Lascia vuoto per consentire tutte le origini (*). Per sicurezza, specifica il tuo dominio.',
  'forms.settings.tracking.messageFormat': 'Formato messaggio',
  'forms.validation.required': 'è obbligatorio',
  'forms.validation.invalidEmail': 'Inserisci un indirizzo email valido',
  'forms.validation.invalidPhone': 'Inserisci un numero di telefono valido',
  'forms.validation.invalidNumber': 'Inserisci un numero valido',
  'forms.validation.minValue': 'Deve essere almeno',
  'forms.validation.maxValue': 'Deve essere al massimo',
  'forms.validation.minLength': 'Deve essere almeno',
  'forms.validation.maxLength': 'Deve essere al massimo',
  'forms.validation.characters': 'caratteri',
  'forms.validation.invalidFormat': 'Formato non valido',
  'forms.toast.fixErrors': 'Correggi gli errori qui sotto',
  'forms.toast.thankYou': 'Grazie per il tuo invio!',
  'forms.toast.submitted': 'Modulo inviato con successo!',
  'forms.toast.errorSubmitting': "C'è stato un errore nell'invio del modulo",
  'forms.toast.submissionFailed': 'Invio fallito. Riprova.',
};
